import getAbbreviatedMonth from './getAbbreviatedMonth';

/**
 * Returns the abbreviated month and day of a Date (i.e. July 7)
 */
var getAbbreviatedMonthAndDay = function getAbbreviatedMonthAndDay(date) {
  return "".concat(getAbbreviatedMonth(date), " ").concat(date.getDate());
};
export default getAbbreviatedMonthAndDay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/date/getAbbreviatedMonthAndDay.js
// module id = 2565
// module chunks = 11